@if (application(); as application) {
  <div class="application-details">
    <div class='row'>
      <div class='col-md-3'>
        <app-label label='Data utworzenia:'>
          {{ application?.createdAt | date }}
        </app-label>
      </div>
      <div class='col-md-3'>
        <app-label label='Data zatwierdzenia:'>
          {{ application?.updatedAt | date }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Numer sprawy:'>
          {{ application?.caseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <ng-container *ngIf='shipments()?.length'>
      <br>
      <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
      </app-decision-data-preview>
      <br>
    </ng-container>
    <app-applicant-preview
      [application]="application"
      [expanded]="expanded">
    </app-applicant-preview>
    <br>
    <h3>
      Dane wniosku
    </h3>
    <app-application-data-preview [application]="application">
    </app-application-data-preview>
    <br>
    <h3>
      Dane przejazdu
    </h3>
    <div class="row">
      <div class="col-md-3">
        <app-label label="Data od:">
          {{ application?.startDate | date }}
        </app-label>
      </div>
      <div class="col-md-3">
        <app-label label="Data do:">
          {{ application?.endDate | date }}
        </app-label>
      </div>
    </div>
    <br>
    @if (application?.applicationSubject === 'Kategorii I') {
      <div class="row">
        <div class="col-12">
          <p class="mb-2">
            <strong>
              Dane pojazdu
            </strong>
          </p>
          @if ((application?.vehicles || [])[0]; as item) {
            <div class="row">
              <div class='col-md-6'>
                <app-label label='Typ pojazdu'>
                  {{ item?.vehicleCategory || '-' }}
                </app-label>
              </div>
              <div class='col-md-6'>
                <app-label label='Marka pojazdu:'>
                  {{ item?.vehicleType || '-' }}
                </app-label>
              </div>
              <div class='col-12'>
                <app-label label='Numer rejestracyjny albo numer nadwozia, podwozia lub ramy:'>
                  {{ item?.registrationNumberOrChassisNumber || '-' }}
                </app-label>
              </div>
            </div>
          }
          <br>
        </div>
      </div>
      <br>
    }
    <h3>
      Podmiot zlecający przejazd
    </h3>
    <div class="row">
      <div class="col-md-4">
        <app-label label="Nazwa:">
          {{ application?.orderingEntityName || '-' }}
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label="Kod pocztowy:">
          {{ application?.orderingEntityPostalCode || '-' }}
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label="Poczta:">
          {{ application?.orderingEntityName || '-' }}
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label="Miejscowość:">
          {{ application?.orderingEntityCity || '-' }}
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label="Ulica:">
          {{ application?.orderingEntityStreet || '-' }}
        </app-label>
      </div>
      <div class="col-md-2">
        <app-label label="Nr domu:">
          {{ application?.orderingEntityHouseNumber || '-' }}
        </app-label>
      </div>
      <div class="col-md-2">
        <app-label label="Nr mieszkania:">
          {{ application?.orderingEntityApartmentNumber || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <h3>
      Zgody
    </h3>
    <app-agreements-data-preview [application]="application">
    </app-agreements-data-preview>
    <br>
    <h3>
      Załączniki
    </h3>
    <app-attachments-data-preview [application]="application">
    </app-attachments-data-preview>
  </div>
}
